export const DrawerWidth = 730;

export const DrawerWidthSmall = 500;
